import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import querystring from 'query-string';

import { useStyles } from '~/assets/styles';
import { MIXPANEL_EVENTS } from '~/pocs/mixpanel';

import { trackAction } from '../Utils';

import mixpanel from './CmsMain/mixpanel';
import TooltipIcon from './core/TooltipIcon';
import { useHasPermission } from './hooks/useHasPermission';
import { PERMISSION_ACTIONS, PERMISSION_VERBS } from './core';
import InlineIconButton from './InlineIconButton';

const ClaimLink = ({ claimId, linkText, extraLinkArgs, trackingInfo, onClick, disabled }) => {
  const location = useLocation();
  const userHasClaimPermissions = useHasPermission({ action: PERMISSION_ACTIONS.CLAIM, verb: PERMISSION_VERBS.READ });
  const { classes } = useStyles();

  let linkUrl = userHasClaimPermissions && !disabled ? `/claims/${claimId}` : null;

  if (extraLinkArgs && linkUrl) {
    linkUrl += `?${querystring.stringify(extraLinkArgs)}`;
  }

  const handleClickOpenInNewTabIcon = () => {
    mixpanel.track(MIXPANEL_EVENTS.OPEN_CLAIM_IN_NEW_TAB_CLICKED, {
      link_url: linkUrl,
      prev_location: location.pathname,
    });
    window.open(linkUrl, '_blank');
  };

  const handleClick = (e) => {
    mixpanel.track(MIXPANEL_EVENTS.OPEN_CLAIM_LINK_CLICKED, { link_url: linkUrl, prev_location: location.pathname });
    if (trackingInfo) {
      trackAction(location, trackingInfo);
    }
    e.stopPropagation();
  };

  if (!linkUrl) {
    return <span className={classes.subtleLinkText}>{linkText}</span>;
  }

  return (
    <div className="flex items-center">
      <Link
        className={classes.subtleLinkText + ' pr-4'}
        onMouseDown={handleClick} // use onMouseDown and not onClick to catch pressing the link with the mouse's middle button to open in new tab.
        onClick={onClick}
        to={linkUrl}
      >
        {linkText}
      </Link>
      <div className="pt-4">
        <TooltipIcon title="Open in a new tab" arrow>
          <InlineIconButton defaultColor="action" icon={OpenInNewIcon} onClick={handleClickOpenInNewTabIcon} />
        </TooltipIcon>
      </div>
    </div>
  );
};

ClaimLink.propTypes = {
  claimId: PropTypes.number.isRequired,
  linkText: PropTypes.string.isRequired,
  extraLinkArgs: PropTypes.object,
  trackingInfo: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ClaimLink;
